module.exports = __webpack_public_path__ + "img/202603_01.593d2fba.png";